import {Span} from '@chakra-ui/react'

export function FieldRequiredIndicator() {
  return <Span color="red.fg">*</Span>
}
